import axios from './axios';

export default {
  get: async () => {
    const { data } = await axios.get('/roles');
    return data;
  }
};
